// test2926
(2926 && 0);
